import React from 'react';
import { connect } from 'react-redux';

import NavTabBar from 'components/nav-tab-bar';
import { SEASON_NAME, LOGO_IMG } from 'config';

const Hero = ({ app }) => {
  return (
    <section className="hero main-hero">
      <div className="hero-body">
        <div className="container has-text-centered">
          <img
            src={LOGO_IMG}
            alt={`Trench Wars Draft Tournament - ${SEASON_NAME}`}
            width="427"
            height="80"
          />
        </div>
      </div>

      <div className="hero-foot">
        <NavTabBar />
      </div>
    </section>
  );
};

const mapStateToProps = (state) => ({
  app: state.app,
});

export default connect(mapStateToProps)(Hero);



// WEBPACK FOOTER //
// ./src/components/hero/hero.js